import type { ReactNode } from "react";
import styled from "@emotion/styled";
import { SubscriptionBackButton } from "./SubscriptionBackButton";

const Row = styled.div<{ $marginBottom: string }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: ${(p) => p.$marginBottom};
`;

type Props = {
  onBack?: () => void;
  backDisabled?: boolean;
  marginBottom?: string;
  children: ReactNode;
};

export const SubscriptionStepHeader = ({
  onBack,
  backDisabled,
  marginBottom = "0.5rem",
  children,
}: Props) => (
  <Row $marginBottom={marginBottom}>
    {onBack && (
      <SubscriptionBackButton
        iconOnly
        onClick={onBack}
        disabled={backDisabled}
      />
    )}
    {children}
  </Row>
);
